import { TOptions } from 'i18next';
import * as Yup from 'yup';

export interface YupI18nError {
  key: string;
  params: { [key: string]: any };
  options?: TOptions;
}

/**
 * We are using translation objects as error messages, which will be transformed by i18next at a later point.
 *
 * In the frontend this is done using `FormErrorMessage`.
 */
Yup.setLocale({
  mixed: {
    default: params => ({ key: 'mixed.default', params } as YupI18nError),
    required: params => ({ key: 'mixed.required', params } as YupI18nError),
    defined: params => ({ key: 'mixed.defined', params } as YupI18nError),
    oneOf: params => ({ key: 'mixed.oneOf', params } as YupI18nError),
    notOneOf: params => ({ key: 'mixed.notOneOf', params } as YupI18nError),
    notType: params => ({ key: 'mixed.notType', params } as YupI18nError),
  },
  string: {
    length: params => ({ key: 'string.notType', params } as YupI18nError),
    min: params => ({ key: 'string.min', params } as YupI18nError),
    max: params => ({ key: 'string.max', params } as YupI18nError),
    matches: params => ({ key: 'string.matches', params } as YupI18nError),
    email: params => ({ key: 'string.email', params } as YupI18nError),
    url: params => ({ key: 'string.url', params } as YupI18nError),
    uuid: params => ({ key: 'string.uuid', params } as YupI18nError),
    trim: params => ({ key: 'string.trim', params } as YupI18nError),
    lowercase: params => ({ key: 'string.lowercase', params } as YupI18nError),
    uppercase: params => ({ key: 'string.uppercase', params } as YupI18nError),
  },
  number: {
    min: params => ({ key: 'number.min', params } as YupI18nError),
    max: params => ({ key: 'number.max', params } as YupI18nError),
    lessThan: params => ({ key: 'number.lessThan', params } as YupI18nError),
    moreThan: params => ({ key: 'number.moreThan', params } as YupI18nError),
    positive: params => ({ key: 'number.positive', params } as YupI18nError),
    negative: params => ({ key: 'number.negative', params } as YupI18nError),
    integer: params => ({ key: 'number.integer', params } as YupI18nError),
  },
  date: {
    min: params => ({ key: 'date.min', params } as YupI18nError),
    max: params => ({ key: 'date.max', params } as YupI18nError),
  },
  object: {
    noUnknown: params => ({ key: 'object.noUnknown', params } as YupI18nError),
  },
  array: {
    min: params => ({ key: 'array.min', params, options: { count: params.min } } as YupI18nError),
    max: params => ({ key: 'array.max', params, options: { count: params.max } } as YupI18nError),
    length: params => ({ key: 'array.length', params, options: { count: params.length } } as YupI18nError),
  },
  boolean: {
    isValue: params =>
      ({ key: `boolean.isValue.${Boolean(params.value) === true ? 'true' : 'false'}`, params } as YupI18nError),
  },
});

export default Yup;
